import React, { Fragment } from 'react';
import { Button, Form, Grid, Icon, Label, Loader, Popup, Table } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import { fetchMarks } from '../../Lookups/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

export default class StudentGrades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            grades: {},
            gradesArray: [],
            mark: null,

            loading: true,
            confirmation: false,
        };
        this.deleteMark = this.deleteMark.bind(this);
        this.getGrade = this.getGrade.bind(this);
        this.editGrade = this.editGrade.bind(this);
        this.getMarkLookup = this.getMarkLookup.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this.getGrade();
        if (localStorage.getItem('activeRole') === 'Administrator') this.getMarkLookup();
    }

    getMarkLookup() {
        fetchMarks()
            .then(res => {
                const marks = res.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).displayName : el.displayName),
                    passed: el.passed,
                    key_: el._key,
                    letter: el.letter
                }));
                this.setState({
                    marks
                });
            })
            .catch(err => {
                console.log('Failed to fetch lkp marks!');
            });
    }

    getGrade() {
        axios.get(`/student-exams/grades/${this.props.studentId}`)
            .then(res => {
                const grades = res.data;
                const gradesArray = res.data.grades;
                this.setState({
                    grades, gradesArray, loading: false, average: grades.gradeAverage
                });
            })
            .catch(err => {
                console.log('Failed to fetch student grades');
            });
    }

    editGrade(mark) {
        let obj = {
            studentMarkId: mark.id,
            optLock: mark.optLock,
            markId: this.state.mark

        };
        axios.put('grade-student/edit-grade', { ...obj })
            .then(res => {
                toast('Uspješno ste izmijenili ocjenu.');
                this.getGrade();
                this.setState({
                    mark: null, loaderForEditing: false, edit: false, currentMarkId: -1
                });
            })
            .catch(err => {
                this.setState({ loaderForEditing: false });
                if (err.response.data === 'Student mark has been already changed!') {
                    toast('Ocjena je već izmijenjena. Pokušajte ponovo.');
                } else if (err.response.data === 'Could not edit date and mark for passed student mark!') {
                    toast('Nije moguće mijenjati datum ocjene.');
                } else {
                    toast('Došlo je do greške.');
                }
            });
    }
    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }
    deleteMark(markId, optLock) {
        this.setState({ loader: true, confirmation: false });
        let obj = {
            id: markId,
            optLock
        };
        axios.delete(`/grade-student/delete-grade/${this.props.studentId}/`, { data: obj })
            .then((res) => {
                this.setState({ loader: false });
                toast('Uspješno ste izbrisali ocjenu!');
                this.getGrade();
            }).catch(err => {
                this.setState({ loader: false });
                if (err.response.data === 'Student mark is changed!') {
                    toast('Ocjena je izmijenjena u međuvremenu. Pokušajte ponovo!');
                } else {
                    toast('Došlo je do greške! Ocjena nije izbrisana!');
                }
            });
    }


    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active /></div>;


        const { grades, gradesArray, average } = this.state;
        const { locked } = JSON.parse(localStorage.getItem('student'));
        return (
            <div>
                { this.state.loader && <Loader active inline="centered" /> }
                {gradesArray.length ?
                    <Table structured celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan="5" >Predmet</Table.HeaderCell>
                                <Table.HeaderCell width={3}>Profesor</Table.HeaderCell>
                                {/* <Table.HeaderCell>Semestar</Table.HeaderCell> */}
                                <Table.HeaderCell width="1">ECTS</Table.HeaderCell>
                                <Table.HeaderCell colSpan="2">Datum ispita</Table.HeaderCell>
                                <Table.HeaderCell colSpan="2">Datum unosa ocjene</Table.HeaderCell>
                                <Table.HeaderCell colSpan={this.state.edit ? '3' : '2'}>Ocjena</Table.HeaderCell>
                                {(!locked && (this.props.thirdCycle || localStorage.getItem('activeRole') === 'Administrator')) && <Table.HeaderCell colSpan="2"> </Table.HeaderCell>}

                            </Table.Row>
                        </Table.Header>

                        <Table.Body> {gradesArray.map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle">
                                    {index + 1}.
                                </Table.Cell>
                                <Table.Cell colSpan="5" verticalAlign="middle">
                                    <Grid columns={1} centered stackable>
                                        <Grid.Column width="12">
                                            {el.courseName}
                                        </Grid.Column>
                                        <Grid.Column width="4" verticalAlign="middle" textAlign="right">
                                            <span>
                                                {el.examRecognition && <Popup content="Priznavanje" hideOnScroll position="top center" trigger={<Label size="tiny" as="a" basic><span><Icon name="check" color="blue" /></span></Label>} />}
                                                {el.courseEquivalence && <Popup content="Ekvivalencija" hideOnScroll position="top center" trigger={<Label size="tiny" as="a" basic><span><Icon name="exchange" color="blue" /></span></Label>} />}
                                                {el.mobilityGrade && <Popup content="Mobilnost" hideOnScroll position="top center" trigger={<Label size="tiny" as="a" basic><span><Icon name="sync alternate" color="blue" /></span></Label>} />}
                                            </span>
                                        </Grid.Column>
                                    </Grid>

                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" width={3}>
                                    {el.teacher}
                                </Table.Cell>
                                {/* <Table.Cell verticalAlign="middle"> */}
                                {/* {el.semester} */}
                                {/* </Table.Cell> */}
                                <Table.Cell verticalAlign="middle">
                                    {el.ects}
                                </Table.Cell>
                                <Table.Cell colSpan="2" verticalAlign="middle">
                                    {moment(el.examDate).format('D. M. YYYY.')}
                                </Table.Cell>
                                <Table.Cell colSpan="2" verticalAlign="middle">
                                    {el.inputDate ? moment(el.inputDate).format('D. M. YYYY.') : ''}
                                </Table.Cell>
                                <Table.Cell colSpan={this.state.edit ? '3' : '2'} verticalAlign="middle">
                                    {this.state.edit && this.state.currentMarkId === el.id ? <Form>
                                        <Form.Field>
                                            <Form.Dropdown
                                                selection
                                                options={this.state.marks.filter(el => (el.key_ !== 'nz' && el.key_ !== 'no' && el.key_ !== 'not_defended'))}
                                                onChange={this.handleInputChange}
                                                value={this.state.mark ? this.state.mark : el.markId}
                                                name="mark"
                                                placeholder="Odaberite ocjenu"
                                                search
                                                fluid
                                            />
                                        </Form.Field>
                                    </Form> : el.mark}
                                </Table.Cell>
                                {(!locked && (this.props.thirdCycle || localStorage.getItem('activeRole') === 'Administrator')) && <Table.Cell colSpan="2" verticalAlign="middle" textAlign="center">

                                    {this.state.confirmation === index ?
                                        <div>
                                            <h4> Jeste li sigurni?</h4>
                                            {/* <Button.Group> */}
                                            <span>
                                                <Button
                                                    compact
                                                    basic="true"
                                                    color="blue"
                                                    onClick={() => this.deleteMark(el.id, el.optLock)}
                                                > DA</Button>
                                                <Button
                                                    compact
                                                    basic="true"
                                                    color="red"
                                                    onClick={() => { this.setState({ confirmation: false }); }}
                                                >  NE

                                                </Button>
                                            </span>
                                            {/* </Button.Group> */}
                                        </div>

                                        : <Fragment>
                                            {(!locked && this.props.thirdCycle) && <Popup
                                                content="Brisanje"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        disabled={el.mobilityGrade || el.examRecognition || el.courseEquivalence}
                                                        basic="true"
                                                        circular
                                                        icon="trash alternate"
                                                        size="small"
                                                        color="red"
                                                        onClick={() => this.setState({ confirmation: index })}
                                                    />}
                                            />}
                                            {localStorage.getItem('activeRole') === 'Administrator' ?

                                                (this.state.edit && this.state.currentMarkId === el.id) ?
                                                    <Fragment>
                                                        <Popup
                                                            content="Sačuvaj"
                                                            position="top center"
                                                            trigger={
                                                                <Button
                                                                    loading={this.state.loaderForEditing}
                                                                    basic="true"
                                                                    circular
                                                                    size="small"
                                                                    color="blue"
                                                                    icon="check"
                                                                    onClick={() => { this.setState({ loaderForEditing: true }); this.editGrade(el); }}
                                                                />}
                                                        />
                                                        <Popup
                                                            content="Odustani"
                                                            position="top center"
                                                            trigger={
                                                                <Button
                                                                    basic="true"
                                                                    circular
                                                                    size="small"
                                                                    color="red"
                                                                    icon="close"
                                                                    onClick={() => { this.setState({ edit: false, currentMarkId: -1 }); }}
                                                                />}
                                                        />
                                                    </Fragment> :
                                                    <Popup
                                                        content="Izmjena"
                                                        position="top center"
                                                        trigger={
                                                            <Button

                                                                disabled={el.mobilityGrade || el.examRecognition || el.courseEquivalence || (this.state.edit && this.state.currentMarkId !== el.id)}
                                                                basic="true"
                                                                circular
                                                                icon="pencil"
                                                                size="small"
                                                                color="green"
                                                                onClick={() => { this.setState({ currentMarkId: el.id, edit: true }); }}
                                                            />}
                                                    /> : ''
                                            }
                                        </Fragment>

                                    }

                                </Table.Cell>}
                            </Table.Row>))}
                        </Table.Body>

                        <Table.Footer>
                            <Table.Row >
                                <Table.HeaderCell colSpan="10" rowSpan="3" />
                                <Table.HeaderCell colSpan={(!locked && (this.props.thirdCycle || localStorage.getItem('activeRole') === 'Administrator')) ? this.state.edit ? '7' : '6' : '4'}>
                                    <h4>  Broj položenih ispita: {gradesArray.length}</h4>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row >
                                <Table.HeaderCell colSpan={(!locked && (this.props.thirdCycle || localStorage.getItem('activeRole') === 'Administrator')) ? this.state.edit ? '7' : '6' : '4'}>
                                    <h4>  Prosjek ocjena: {average}</h4>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row >
                                <Table.HeaderCell colSpan={(!locked && (this.props.thirdCycle || localStorage.getItem('activeRole') === 'Administrator')) ? this.state.edit ? '7' : '6' : '4'}>
                                    <h4>Ukupno ECTS bodova: {grades.ectsTotal}</h4>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row >
                            </Table.Row>
                        </Table.Footer>
                    </Table>
                    :
                    'Nema ocjena za traženog studenta.'
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/StudentGrades.js